var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBannerGraphics = function SvgBannerGraphics(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.6 24.8H14.4v52h67.2v-52ZM79.955 13.637a4.43 4.43 0 0 1-1.239-2.437h-.649a4.399 4.399 0 0 1-1.238 2.437 4.399 4.399 0 0 1-2.437 1.239v.649a4.4 4.4 0 0 1 2.437 1.238 4.4 4.4 0 0 1 1.238 2.437h.65a4.4 4.4 0 0 1 1.238-2.437 4.4 4.4 0 0 1 2.437-1.238v-.65a4.399 4.399 0 0 1-2.437-1.238ZM14.363 14.437A4.43 4.43 0 0 1 13.124 12h-.649a4.399 4.399 0 0 1-1.238 2.437A4.399 4.399 0 0 1 8.8 15.676v.649a4.4 4.4 0 0 1 2.437 1.238A4.4 4.4 0 0 1 12.475 20h.65a4.4 4.4 0 0 1 1.238-2.437 4.4 4.4 0 0 1 2.437-1.238v-.65a4.399 4.399 0 0 1-2.437-1.238Z",
    fill: "#C2E2FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52 36.8H20V68h32V36.8Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68 44.8h-8.8V44H68v.8ZM75.2 48.8h-16V48h16v.8ZM75.2 52.8h-16V52h16v.8Z",
    fill: "#192C55"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2 56.8h-8a2 2 0 1 0 0 4h8a2 2 0 1 0 0-4Z",
    fill: "#28BF9A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36 48.8c5.744 0 10.4-1.791 10.4-4 0-2.21-4.656-4-10.4-4-5.744 0-10.4 1.79-10.4 4 0 2.209 4.656 4 10.4 4ZM36 64c5.744 0 10.4-1.791 10.4-4 0-2.21-4.656-4-10.4-4-5.744 0-10.4 1.79-10.4 4 0 2.209 4.656 4 10.4 4Z",
    fill: "#C2E2FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m36 45.6-9.6 6.804L36 59.2l9.6-6.796L36 45.6Z",
    fill: "#C2E2FF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "banner-graphics_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 2,
    width: 91,
    height: 92
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.657 58.336C2.513 70.192 3.081 80.824 9.313 87.064c11.624 11.624 38.536 3.56 60.112-18.016C91.001 47.472 99.065 20.56 87.441 8.936c-9.144-9.144-27.752-6.104-45.784 6.12",
    stroke: "#192C55",
    strokeWidth: 1.333,
    strokeMiterlimit: 10
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#banner-graphics_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#banner-graphics_svg__b)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 84.377,
    cy: 16.8,
    r: 31.2,
    fill: "#0021FF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#banner-graphics_svg__c)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 74.777,
    cy: 58.4,
    r: 33.6,
    fill: "#116DFF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#banner-graphics_svg__d)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 28,
    cy: 89.2,
    rx: 23.2,
    ry: 23.6,
    fill: "#5FF2AE"
  })))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M81.6 24.8H14.4v4.8h67.2v-4.8ZM31.854 10.546A7.38 7.38 0 0 1 29.75 6.4h-1.1c-.24 1.58-.984 3.005-2.104 4.146A7.315 7.315 0 0 1 22.4 12.65v1.1c1.58.24 3.005.984 4.146 2.104A7.315 7.315 0 0 1 28.65 20h1.1c.24-1.581.984-3.005 2.104-4.146A7.315 7.315 0 0 1 36 13.75v-1.1c-1.581-.24-3.005-.984-4.146-2.104ZM70.43 84.77a5.703 5.703 0 0 1-1.609-3.17h-.842a5.734 5.734 0 0 1-1.609 3.17 5.674 5.674 0 0 1-3.17 1.609v.842c1.211.199 2.3.738 3.17 1.609.87.87 1.42 1.959 1.609 3.17h.842a5.733 5.733 0 0 1 1.609-3.17 5.673 5.673 0 0 1 3.17-1.609v-.842a5.734 5.734 0 0 1-3.17-1.609ZM54.4 9.6c.88 0 1.6-.72 1.6-1.6 0-.88-.72-1.6-1.6-1.6-.88 0-1.6.72-1.6 1.6 0 .88.72 1.6 1.6 1.6Z",
    fill: "#116DFF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "banner-graphics_svg__b",
    x: 51.177,
    y: -16.4,
    width: 66.4,
    height: 66.4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_9083_7288"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "banner-graphics_svg__c",
    x: 29.177,
    y: 12.8,
    width: 91.2,
    height: 91.2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    result: "effect1_foregroundBlur_9083_7288"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "banner-graphics_svg__d",
    x: -15.2,
    y: 45.6,
    width: 86.4,
    height: 87.2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "effect1_foregroundBlur_9083_7288"
  })))));
};
export default SvgBannerGraphics;